import styled from 'styled-components'
import { smStyle } from '@/components/Adapter'

export const PriceBannerStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  position: relative;

  ${smStyle} {
    margin-top: 80px;
  }
`

export const PriceTabsStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`

export const PriceTitleStyled = styled.h1`
  color: var(--color-text-1);
  font-size: 28px;
  font-weight: 700;
  line-height: 120%;
  margin-bottom: 24px;

  ${smStyle} {
    font-size: 48px;
    margin-bottom: 40px;
  }
`

export const PriceBannerSkeletonStyled = styled.div`
  width: 100%;
  margin-top: 24px;
`

export const PriceBannerItemHtmlStyled = styled.div`
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  line-height: 1.5em;
  max-height: 7.5em;
  height: 7.5em;
  position: relative;

  @media (min-width: 1480px) {
    max-height: 7.2em; /* 确保与行高完全匹配 */
    height: 7.2em;
  }

  /* 子元素强制限制 */
  > * {
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    white-space: normal;
  }

  /* 使用伪元素实现 "..." */
  &::after {
    content: '...';
    position: absolute;
    bottom: 4px;
    right: 0;
    background: var(--color-bg-1);
    padding-left: 2px;
    text-align: right;
    display: block;
    color: var(--color-text-1);
  }
`
